import { Routes } from '@angular/router';
import { LandingComponent } from './containers/landing/landing.component';
import { MsalGuard } from '@azure/msal-angular';
import { UnexpectedErrorComponent } from './shared/unexpected-error/unexpected-error.component';
import { internalUserAuthGuard } from './guards/internal-user-auth.guard';
import { externalUserAuthGuard } from './guards/external-user-auth.guard';
import { RequestAccountComponent } from './containers/request-account/request-account.component';
import { RedirectComponent } from './containers/redirect/redirect.component';
import { AccessibilityComponent } from './containers/accessibility/accessibility.component';
import { ErrorComponent } from './shared/error/error.component';
import { PermissionsErrorComponent } from './shared/permissions-error/permissions-error.component';
import { NotFoundErrorComponent } from './shared/not-found-error/not-found-error.component';

function retryImport<T>(importFn: () => Promise<T>, retries = 3, forceReload = true): Promise<T> {
  return importFn().catch((err) => {
    if (retries <= 0) {
      if (forceReload && err.message?.includes('Failed to fetch')) {
        window.location.reload();
      }
      throw err;
    }
    return new Promise(resolve => setTimeout(resolve, 1000))
      .then(() => retryImport(importFn, retries - 1, forceReload));
  });
}

export const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'redirect', component: RedirectComponent },
  {
    path: 'request-an-account',
    component: RequestAccountComponent,
    title: 'Request an account - Data Upload - UKHO'
  },
  {
    path: 'internal',
    loadChildren: () =>
      retryImport(() => import('./internal/internal.routes').then((m) => m.INTERNAL_ROUTES)),
    canActivate: [MsalGuard, internalUserAuthGuard]
  },
  {
    path: 'external',
    loadChildren: () =>
      retryImport(() => import('./external/external.routes').then((m) => m.EXTERNAL_ROUTES)),
    canActivate: [MsalGuard, externalUserAuthGuard]
  },
  { path: 'accessibility', component: AccessibilityComponent, title: 'Accessibility statement - Data Upload - UKHO' },
  { path: 'error', component: ErrorComponent, title: 'Error' },
  { path: 'permissions-error', component: PermissionsErrorComponent, title: 'Permissions error' },
  { path: 'not-found-error', component: NotFoundErrorComponent, title: 'Not found error' },
  { path: 'unexpected-error', component: UnexpectedErrorComponent, title: 'Error' },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

